export default {
  familyName: 'Arial',
  fullName: 'Arial Bold',
  postscriptName: 'Arial-BoldMT',
  category: 'sans-serif',
  capHeight: 1466,
  ascent: 1854,
  descent: -434,
  lineGap: 67,
  unitsPerEm: 2048,
  xHeight: 1062,
  xWidthAvg: 983,
  subsets: {
    latin: {
      xWidthAvg: 983
    },
    thai: {
      xWidthAvg: 1536
    }
  }
};
